import { useState } from "react";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import TextField from "../form/TextField";
import Spacer from "../Spacer";
import Button from "../shared/Button";
import { forgotPassword } from "../../api/auth";
import ResendPasswordResetEmail from "./ResendPasswordResetEmail";

const ForgotPasswordForm = () => {
  const [isResendScreen, setResendScreen] = useState<boolean>(false);

  const formik = useFormik({
    initialValues: {
      email: ""
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid Email").required("Email is required")
    }),
    onSubmit: async () => {
      await forgotPassword({
        email: formik.values?.email,
        userType: "patient"
      });
      setResendScreen(true);
    }
  });

  return (
    <>
      {!isResendScreen ? (
        <div className="w-full box-border lg:w-[614px] bg-white">
          <div className="text-center">
            <Spacer height={0} />
            <p className="text-[34px] font-[800] text-[#103C1B]">
              Reset Password
            </p>
            <Spacer height={10} />
            <p className="font-[400] text-[20px] text-[#103C1B]">
              Enter your email to receive a link to reset your password.
            </p>
          </div>
          <Spacer height={40} />
          <div className="flex flex-col mx-auto items-center w-full lg:w-[478px]">
            <TextField
              name="email"
              type="email"
              placeholder="name@mail.com"
              value={formik.values.email}
              onChange={formik.handleChange}
              label="Email address"
              error={formik.touched.email ? formik.errors.email : ""}
            />

            <Spacer height={25} />

            <div className="w-[100%] flex justify-end items-center mt-8 text-xs text-normal">
              <div className="flex flex-end">
                <Button
                  additionalClassname={"text-[18px] font-[400] w-[98px]"}
                  height={60}
                  type="submit"
                  variant="primary"
                  label="Submit"
                  onClick={formik.handleSubmit}
                />
              </div>
            </div>
            <div className="lg:h-[80px] h-[40px]" />
            <div className="border-[1px] border-gray-200 w-[300px]" />
            <div className="lg:h-[80px] h-[40px]" />
            <p className="text-center font-[400]">
              Are you a new member?{" "}
              <span className="text-[#1A9D39]">
                {" "}
                <Link to="/patient/signup"> Create an account</Link>
              </span>
            </p>
            <Spacer height={20} />
          </div>
        </div>
      ) : (
        <ResendPasswordResetEmail
          email={formik.values.email}
          userType="patient"
        />
      )}
    </>
  );
};

export default ForgotPasswordForm;
